var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"title"},[_vm._v("Добро пожаловать!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }